module.exports = __webpack_public_path__ + "static/media/391SunsetAveNW_2018-06-11_68.74980108.jpg";